import { translateText } from "infra/translation/translate";
import InputDateComponent from "presentation/components/Shared/InputDateComponent";
import { useFilterTripsheetStore } from "presentation/stores/use-filter-tripsheet-store";
import { useTripsheetDateFilterStore } from "presentation/stores/use-tripsheets-date-filter-store";
import { Button } from "primereact/button";
import { useState } from "react";

const HeaderTripMonthEmployeeGrid: React.FC = () => {
  const { filters, setFilters, resetFilters } = useFilterTripsheetStore();
  const { tripsheetDateFilter, setTripsheetDateFilter } = useTripsheetDateFilterStore();

  const clearFilter = () => {
    resetFilters();
    setTripsheetDateFilter({date: new Date()});
    setFilters({
      query: { value: "", matchMode: "contains" },
      "employee.employeeNumber": { value: "", matchMode: "equals" },
      "employee.name": { value: "", matchMode: "contains" },
      kmValueCalculated: { value: "", matchMode: "equals" },
      status: { value: "", matchMode: "equals" },
    });
  };

  return (
    <div className="flex justify-content-between">
      <div>
        <InputDateComponent
          label="Data"
          fieldName="date"
          currentObject={tripsheetDateFilter}
          getValue={tripsheetDateFilter?.date}
          setValue={setTripsheetDateFilter}
          view="month"
          dateFormat="yy-mm"
        />
      </div>
      <div style={{ display: "flex" }}>
        <div style={{ width: "10px" }}></div>
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label={translateText("Clean", "pt")}
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "white",
            borderColor: "#2196F3",
            color: "#2196F3",
            borderRadius: "8px",
          }}
        />
      </div>
    </div>
  );
};
export default HeaderTripMonthEmployeeGrid;
